module.exports = __webpack_public_path__ + "img/mamadays_shop_footer.ca258aef.png";